export default __webpack_public_path__ + "static/media/SSD.a5a05542.svg";